<template>
  <div id="subject-analyze">
    <div class="title">
      <img :src="require('../assets/imgs/'+ grade +'/title-banner1-type1.png')" alt />
      <div class="title-inner">
        <b-icon class="title-icon" name="analyze" :color="$util.mainTtleColor(grade)" :size="1.2"></b-icon>
        <p class="title-text" :style="{ color: $util.mainTtleColor(grade)}">考试内容剖析</p>
      </div>
    </div>
    <div id="my-chart" style="width: 100%;height: 350px;"></div>
    <span style="position: absolute;bottom: 5px;right: 5px;color: #ccc;font-size: .5rem;">*点击内容查看分析</span>
  </div>
</template>
<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/radar");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "SubjectAnalyze",
  props: {
    id: {},
    testId: {},
    subjectNum: {},
    indicatorList: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {};
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById("my-chart"));
    // 绘制图表
    myChart.setOption({
      angleAxis: {
        clockwise: true
      },
      //详细配置请参考Echarts官网 https://www.echartsjs.com
      radar: {
        indicator: this.indicatorList,
        center: ["50%", "50%"],
        radius: "50%",
        startAngle: 90,

        splitNumber: 5,
        shape: "circle",
        name: {
          formatter: function(value, indicator) {
            if (parseInt(indicator.num) < 60) {
              return (
                "{warn|" +
                indicator.num +
                "%" +
                "}{tip|}\n" +
                "{title|" +
                value +
                "}" +
                "{img|}" +
                "\n{en|" +
                indicator.en +
                "}"
              );
            } else {
              return (
                "{num|" +
                indicator.num +
                "%" +
                "}\n" +
                value +
                "{img|}" +
                "\n{en|" +
                indicator.en +
                "}"
              );
            }
          },
          rich: {
            title: {
              color: this.$util.echartsZhEn(this.grade),
              align: "center",
              padding: [0, 2, 0, 0]
            },
            en: {
              color: this.$util.echartsZhEn(this.grade),
              align: "center",
              height: "15"
            },
            num: {
              color: this.$util.echartsNum(this.grade),
              align: "center",
              height: 20,
              width: 20
            },
            warn: {
              color: "red",
              align: "center",
              height: 20,
              width: 20
            },
            img: {
              lineHeight: 10,
              align: "center",
              height: 7,
              width: 7,
              backgroundColor: {
                image: this.$util.warn(this.grade)
              }
            },
            tip: {
              lineHeight: 10,
              verticalAlign: "top",
              align: "center",
              height: 5,
              width: 5,
              backgroundColor: {
                image: this.$util.tip(this.grade)
              }
            }
          },
          textStyle: {
            color: this.$util.echartsZhEn(this.grade)
          }
        },
        triggerEvent: true,
        nameGap: 10,
        splitArea: {
          areaStyle: {
            color: this.$util.splitAreaColor(this.grade)
          }
        },
        axisLine: {
          lineStyle: {
            color: this.$util.axisLineColor(this.grade),
            type: "dashed"
          }
        },
        splitLine: {
          lineStyle: {
            color: this.$util.splitLineColor(this.grade)
          }
        }
      },
      series: [
        {
          name: "雷达图",
          type: "radar",
          itemStyle: {
            emphasis: {
              // color: 各异,
              lineStyle: {
                show: false,
                width: 0
              }
            }
          },
          data: [
            {
              value: this.subjectNum,
              name: "图二",
              symbol: "none",
              areaStyle: {
                normal: {
                  color: this.$util.areaColor(this.grade)
                }
              },
              lineStyle: {
                normal: {
                  color: this.$util.areaColor(this.grade)
                }
              }
            }
          ]
        }
      ]
    });
    myChart.on("click", params => {
      console.log(params);
      let format;
      //{title|未来领导力}{img|}
      if (!params.targetType) {
        return;
      }
      if (params.name.indexOf("tip") > 0) {
        format = params.name
          .split(/\n/g)[1]
          .split("{title|")[1]
          .split("}{img|}")[0];
        console.log(format);
      } else {
        format = params.name.split(/\n/g)[1].split("{img|}")[0];
        console.log(format);
      }

      this.$router.push({
        path: `/analyze/${this.testId}/${this.grade}/${format}`
      });
    });
  },
  methods: {}
};
</script>
<style lang="scss">
#subject-analyze {
  width: 100%;
  background: #fff;
  position: relative;
  > .title {
    width: 100%;
    height: 280px;
    /*font-size: 0;*/
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    > .title-inner {
      position: absolute;
      top: 0;
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      padding-left: 5%;
      font-size: 1.2rem;
      color: #7f4224;
      > .title-icon {
        margin-right: 50px;
        width: 1.2em;
        height: 1.3em !important;
      }
      > .title-text {
        font-size: inherit;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubjectAnalyze.vue